/**
 * @description
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    sessionId: number;
    status?: number;
    vlt_status?: number;
    action: string;
}

interface IOutput {
    status: 0 | 1;
    comment_id: number;
    points_result: IPointsResult;
}

export const makeCompletionStatus = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};

export const sendBeanMakeCompletionStatus = (data: FormData): boolean => {
    return navigator.sendBeacon(Api.MAKE_DOC_READ_SPEED_STATUS.url, data)
};

export const makeCompletionStatusOld = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.MAKE_DOC_READ_SPEED_STATUS_OLD, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
